<template>
    <div class="p-6 loading-table" v-if="showPndingAjaxLoad">
        <spinner-color />
    </div>
    <div v-else>
        <data-table-mission :data="this.$store.state.dataList.missions" :header="header" :body="body" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import DataTableMission from "../components/table-components/DataTableMission.vue"
import SpinnerColor from '@/views/components/table-components/SpinnerColor2.vue'
import globalMixin from '@/mixins/mixins.js'

export default {
    mixins: [globalMixin],
    components: {
        DataTableMission,
        SpinnerColor
    },
    data () {
        return {
            header: [
                {head: 'dateOfCreations', key: 'created_at'},
                {head: 'rightDate', key: 'due_date'},
                {head: 'dueDate', key: 'execution_date'},
                {head: 'status', key: 'status'},
                {head: 'code', key: 'code'},
                {head: 'type', key: 'type'},
                {head: 'captain', key: 'captain_name'},
                {head: 'cash', key: 'amount'},
                {head: 'backup', key: 'pickup_cost'},
                {head: 'actions', key: ''}
            ],
            body: ['created_at','due_date', 'execution_date', 'status', 'code', 'type', 'captain_name', 'amount', 'pickup_cost']
        }
    },
    computed: {
    },
    methods: {
      ...mapActions('dataList', ["fetchDataMissions"]),
  },
  async created () {
      let credentials = {
        pageNum: null,
        itemsPerPage: 10
      } 
    this.fetchDataMissions(credentials)
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_loadingTable.scss';
</style>